<template>
  <div class="mx-0">
    <v-img
      height="100vh"
      :src="`imagenes/principal.webp `"
      gradient="to top right, rgba(0,0,0,.5), rgba(0,0,0,.5)"
    >
      <v-layout column align-center justify-center fill-height mx-12>
        <v-flex xs1 sm1 md1 lg1>
          <h1
            :class="[$vuetify.breakpoint.mdAndUp ? 'display-2' : '']"
            class="font-weight-bold white--text text-center"
          >
            Preguntas frecuentes
          </h1>
        </v-flex>
      </v-layout>
    </v-img>
    <v-row align="center" justify="center" class="mx-0">
      <v-col cols="12" sm="12" md="10">
        <v-row
          :class="[$vuetify.breakpoint.mdAndUp ? 'px-10' : '']"
          class="mx-0"
          justify="center"
          align="center"
        >
          <v-col cols="12" sm="12" md="12">
            <v-expansion-panels popout>
              <v-expansion-panel>
                <v-expansion-panel-header class="font-weight-bold">
                  ¿Cuáles son los modos de pago válidos para CAPITALICA?
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  Para realizar sus pagos, puede acudir a nuestras oficinas en
                  Tepic o Puerto Vallarta, o bien puede hacer una transferencia
                  CLABE de su banco.
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header class="font-weight-bold">
                  ¿Cuáles son las sucursales que existen de CAPITALICA?
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  Capitálica actualmente tiene sucursales en Tepic, Nayarit y
                  Puerto Vallarta. Los domicilios de las mismas están indicados
                  <a href="/">aquí</a>.
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header class="font-weight-bold">
                  ¿Qué pasa si no cumplo con un pago?
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  Si usted no cumple puntualmente con su pago suceden algunas
                  cosas importantes que no convienen a su negocio. <br /><br />
                  1. Corre el riesgo de que su crédito no pueda ser renovado
                  cuando su negocio más lo necesita. <br />
                  2. Su historial crediticio en Capitálica se ve afectado,
                  además de que la demora de sus pagos se reporta a Buró de
                  Crédito como lo marca la ley. <br />
                  3. Se le cobran intereses moratorios por cada día que su
                  crédito está vencido, además de que transcurridos cinco días
                  naturales de atraso, se generan gastos de cobranza
                  innecesarios y onerosos para usted.
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header class="font-weight-bold">
                  ¿Cuál es el horario de atención de CAPITALICA?
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  De lunes a viernes de 9:00 AM a 7:00 PM en horario corrido
                  <br />
                  Los sábados de 9:00 AM a 2:00 PM.
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <vc-politic-banner :image="`imagenes/logo.svg`"></vc-politic-banner>
    <vc-footer></vc-footer>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
export default {
  directives: {
    mask,
  },
  data: () => ({
    publicPath: process.env.BASE_URL,
    dialog: false,
    colorBannerText: "Te financiamos hasta un 80% del costo del vehículo",
  }),
};
</script>
<style scoped>
.bg-white {
  background-color: #ffffff !important;
}
.container {
  max-width: 2785px !important;
}
.bg-primary_dark {
  background: #8a172b !important;
}
.animated {
  -webkit-animation: pulse 0.5s infinite alternate;
  animation: pulse 0.5s infinite alternate;
}
@-webkit-keyframes pulse {
  to {
    -webkit-transform: scale(1.05);
  }
}
@keyframes pulse {
  to {
    -webkit-transform: scale(1.05);
    transform: scale(1.05);
  }
}
</style>
